import type { ProjectGraphReadingVariant } from '@avisoma/shared';

/** Other spellings of a 1-document against 1-document pair. Nothing when the node has none. */
export function ReadingVariants({ readingVariants }: { readingVariants: ProjectGraphReadingVariant[] | undefined }) {
  if (readingVariants === undefined || readingVariants.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      <div className="mt-2 font-medium">Reading variants</div>
      {readingVariants.map((variant) => (
        <p key={variant.serial} className="text-sm break-words text-zinc-600 dark:text-zinc-300">
          Read as {variant.serial} in {variant.documents} {variant.documents === 1 ? 'document' : 'documents'}
        </p>
      ))}
    </div>
  );
}
